import "./index.css";

import { Route, Switch, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import ButtonScrollToTop from "components/Interaction/ButtonScrollToTop";
import EnvWarning from "components/EnvWarning";
import Footer from "components/Footer";
import Navigation from "components/Navigation";
import NotificationReplicas from "components/NotificationReplicas";
import { routes } from "config";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
`;

const App = () => {
  const location = useLocation();

  const [showNotificationReplicas, setNotificationReplicas] = useState(false);
  const [
    permanentlyHideNotificationReplicas,
    setPermanentlyHideNotificationReplicas,
  ] = useState(false);
  const setNotificationReplicasRef = useRef(setNotificationReplicas);

  const replicaSlugsWithoutNotification = [
    routes.replicasFAQ.slug,
    routes.replicasPayment.slug,
    routes.replicasPaymentGenerator.slug,
  ].map((slug) => `/${slug}`);

  useEffect(() => {
    if (
      !showNotificationReplicas &&
      !permanentlyHideNotificationReplicas &&
      location.pathname.startsWith(`/${routes.replicas.slug}`) &&
      !replicaSlugsWithoutNotification.includes(location.pathname)
    ) {
      setTimeout(() => setNotificationReplicasRef.current(true), 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Wrapper>
      <Switch>
        {/* AUTO GENERATED ROUTES */}
        {Object.values(routes).map((route) =>
          route.slug ? (
            <Route
              key={route.slug}
              path={`/${route.slug}`}
              exact={!route.isSubRoute}
            >
              {route.page}
            </Route>
          ) : (
            <Route key={"404"}>{route.page}</Route>
          ),
        )}
      </Switch>

      <ButtonScrollToTop />
      <Navigation />
      <Footer />

      <NotificationReplicas
        isVisible={
          !permanentlyHideNotificationReplicas && showNotificationReplicas
        }
        onClose={() => {
          setNotificationReplicasRef.current(false);
          setPermanentlyHideNotificationReplicas(true);
        }}
      />

      <EnvWarning />
    </Wrapper>
  );
};

export default App;
